import React from 'react';

import GenericCardRenderItems from './GenericCardRenderItems';

const ComplementoCartaPorteBaseResumen = ({ data = {} }) => {
  return (
    <div className="d-block mt-2 mb-2">
      <GenericCardRenderItems
        data={data}
        labels={labels(data)}
      />
    </div>
  );
};

const labels = (data = {}) => {
  return [
    {
      label: 'IdCCP',
      index: 'IdCCP',
    },
    {
      label: 'Régimen Aduanero',
      index: 'RegimenAduanero',
    },
    {
      label: 'Registro ISTMO',
      index: 'RegistroISTMO',
    },
    {
      label: 'Ubicación Polo Origen',
      index: 'UbicacionPoloOrigen',
    },
    {
      label: 'Ubicación Polo Destino',
      index: 'UbicacionPoloDestino',
    },
    {
      label: 'Transporte Internacional',
      index: 'TranspInternac',
    },
    {
      label: 'Entrada/Salida Mercancía',
      index: 'EntradaSalidaMerc',
    },
    {
      label: 'País Origen/Destino',
      index: 'PaisOrigenDestino',
    },
    {
      label: 'Vía Entrada/Salida',
      index: 'ViaEntradaSalida',
    },
    {
      label: 'Total Distancia Recorrida',
      index: 'TotalDistRec',
    },
  ];
};

export default ComplementoCartaPorteBaseResumen;
